import { adminConstants } from '../constant/admin-constant';
import { alertActions } from './alert-actions';
import { history } from '../../helper/history';
import { companyService } from '../../services/company';
import { helperFunctions } from '../../helper/helperFunctions';

export const companyActions = {
    getCompany,
    storeCompany,
    editCompany,
    deleteCompany,
    getCompaniesPagination,

    // storeCompanyUser,
    // getCompanyUser,
    // editCompanyUser,
    // getCompanyUsers,
    // deleteCompanyUser,
    
    getCompanyProfileInfo,
    getCompanyAllUsersPagination
};

function getCompanyProfileInfo(id){
    return dispatch => {
        dispatch(request());
        companyService.getCompanyProfileInfo(id)
        .then(
            company => {
                dispatch(success(company));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_COMPANY_PROFILE_INFO_REQUEST } }
    function success(company)   { return { type: adminConstants.GET_COMPANY_PROFILE_INFO_SUCCESS, payload:company } }
    function failure(error) { return { type: adminConstants.GET_COMPANY_PROFILE_INFO_FAILURE, payload:error } }
}


function getCompany(id){
	return dispatch => {
        dispatch(request());
        companyService.getCompany(id)
        .then(
            company => {
                dispatch(success(company));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.GET_COMPANY_REQUEST } }
    function success(company) 	{ return { type: adminConstants.GET_COMPANY_SUCCESS, payload:company } }
    function failure(error) { return { type: adminConstants.GET_COMPANY_FAILURE, payload:error } }
}


function deleteCompany(id){
    return dispatch => {
        dispatch(request());
        companyService.deleteCompany(id)
        .then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function(){ 
                     history.go(0);
                }, 1500);

               
                //history.push('/Admin/Companies');
                //history.push('/Admin/Companies');
                
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.DELETE_COMPANY_REQUEST } }
    function success(response)   { return { type: adminConstants.DELETE_COMPANY_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.DELETE_COMPANY_FAILURE, payload:error } }
}


function storeCompany(companyData, companyId){
    return dispatch => {
        dispatch(request());
        companyService.storeCompany(companyData)
        .then(
            response => {
                dispatch(success(response));
                history.push('/Admin/Companies');
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(failure(error));
                window.scrollTo(0, 0);
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.STORE_COMPANY_REQUEST } }
    function success()   { return { type: adminConstants.STORE_COMPANY_SUCCESS } }
    function failure(error) { return { type: adminConstants.STORE_COMPANY_FAILURE, payload:error } }
}

function editCompany(id, companyData){
    return dispatch => {
        dispatch(request());
        companyService.editCompany(id, companyData)
        .then(
            response => {
                dispatch(success(response));
                var adminType = helperFunctions.adminType();
                if (adminType === 'admin')
                    history.push('/Admin/Companies');
                // else if (adminType === 'company')
                //     history.go(0);
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(failure(error));
                window.scrollTo(0, 0);
                dispatch(alertActions.error(error));
            }
        );
    }

    function request() { return { type: adminConstants.EDIT_COMPANY_REQUEST } }
    function success()   { return { type: adminConstants.EDIT_COMPANY_SUCCESS } }
    function failure(error) { return { type: adminConstants.EDIT_COMPANY_FAILURE, payload:error } }
}

function getCompaniesPagination(page, filter, sort, pageSize){
    return dispatch => {
        dispatch(request())
        companyService.getCompaniesPagination(page, filter, sort, pageSize)
        .then(
            response => {
                dispatch(success(response));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: adminConstants.PAGINATION_COMPANY_REQUEST } }
    function success(response)   { return { type: adminConstants.PAGINATION_COMPANY_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.PAGINATION_COMPANY_FAILURE, payload:error } }
}

// function storeCompanyUser(companyUserData, companyId){
//     return dispatch => {
//         dispatch(request());
//         companyService.storeCompanyUser(companyUserData, companyId)
//         .then(
//             response => {
//                 dispatch(success(response));
//                 dispatch(alertActions.success(response.message));
//                 setTimeout(function(){ 
//                     history.go(0);
//                 }, 1500);
                
//                 // history.push('/Admin/Company/'+companyId+'/users');
//                 // location.reload();
                
//                 // history.go(0);
//             },
//             error => {
//                 dispatch(failure(error));
//                 dispatch(alertActions.error(error));
//             }
//         );
//     }

//     function request() { return { type: adminConstants.STORE_COMPANY_USER_REQUEST } }
//     function success(response)   { return { type: adminConstants.STORE_COMPANY_USER_SUCCESS } }
//     function failure(error) { return { type: adminConstants.STORE_COMPANY_USER_FAILURE, payload:error } }
// }


// function getCompanyUser(id){
//     return dispatch => {
//         dispatch(request());
//         companyService.getCompanyUser(id)
//         .then(
//             companyUser => {
//                 dispatch(success(companyUser));
//             },
//             error => {
//                 dispatch(failure(error));
//                 dispatch(alertActions.error(error));
//             }
//         );
//     }

//     function request() { return { type: adminConstants.GET_COMPANY_USER_REQUEST } }
//     function success(companyUser)   { return { type: adminConstants.GET_COMPANY_USER_SUCCESS, payload:companyUser } }
//     function failure(error) { return { type: adminConstants.GET_COMPANY_USER_FAILURE, payload:error } }
// }

// function editCompanyUser(companyUserData, companyId, userId){

//     return dispatch => {
//         dispatch(request());
//         companyService.editCompanyUser(companyUserData, companyId, userId)
//         .then(
//             response => {
//                 dispatch(success(response));
//                 dispatch(alertActions.success(response.message));
//                 setTimeout(function(){ 
//                     history.go(0);
//                 }, 1500);
//                 // history.push('/Admin/Companies');
                
//             },
//             error => {
//                 dispatch(failure(error));
//                 dispatch(alertActions.error(error));
//             }
//         );
//     }

//     function request() { return { type: adminConstants.EDIT_COMPANY_USER_REQUEST } }
//     function success(response)   { return { type: adminConstants.EDIT_COMPANY_USER_SUCCESS, payload:response } }
//     function failure(error) { return { type: adminConstants.EDIT_COMPANY_USER_FAILURE, payload:error } }
// }


// function deleteCompanyUser(companyId, userId){
//     return dispatch => {
//         dispatch(request());
//         companyService.deleteCompanyUser(companyId, userId)
//         .then(
//             response => {
//                 dispatch(success(response));
//                 dispatch(alertActions.success(response.message));
//                 setTimeout(function(){ 
//                     history.go(0);
//                 }, 1500);

                
//                 //history.push('/Admin/Companies');
//                 //history.push('/Admin/Companies');
                
//             },
//             error => {
//                 dispatch(failure(error));
//                 dispatch(alertActions.error(error));
//             }
//         );
//     }

//     function request() { return { type: adminConstants.DELETE_COMPANY_USER_REQUEST } }
//     function success(response)   { return { type: adminConstants.DELETE_COMPANY_USER_SUCCESS, payload:response } }
//     function failure(error) { return { type: adminConstants.DELETE_COMPANY_USER_FAILURE, payload:error } }
// }


// function getCompanyUsers(companyId){

//     return dispatch => {
//         dispatch(request());
//         companyService.getCompanyUsers(companyId)
//         .then(
//             response => {
//                 dispatch(success(response));
//             },
//             error => {
//                 dispatch(failure(error));
//                 dispatch(alertActions.error(error));
//             }
//         );
//     }

//     function request() { return { type: adminConstants.GET_COMPANY_USERS_REQUEST } }
//     function success(response)   { return { type: adminConstants.GET_COMPANY_USERS_SUCCESS, payload:response } }
//     function failure(error) { return { type: adminConstants.GET_COMPANY_USERS_FAILURE, payload:error } }
// }

function getCompanyAllUsersPagination(page, filter, sort, pageSize){
    return dispatch => {
        dispatch(request())
        companyService.getCompanyAllUsersPagination(page, filter, sort, pageSize)
        .then(
            response => {
                dispatch(success(response));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: adminConstants.GET_COMPANY_ALL_USERS_REQUEST } }
    function success(response)   { return { type: adminConstants.GET_COMPANY_ALL_USERS_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.GET_COMPANY_ALL_USERS_FAILURE, payload:error } }
}



// WEBPACK FOOTER //
// ./src/redux/actions/company-action.jsx